import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

@Injectable({ providedIn: 'root' })
export class GtmService {
  constructor() {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  public pushEvent(eventName: string, eventData: Record<string, unknown> = {}): void {
    window.dataLayer.push({
      event: eventName,
      ...eventData
    });
  }
}
